import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SupportChat from "@/components/SupportChat";
import ProtectedRoute from "@/components/layout/ProtectedRoute";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Categories from "@/pages/Categories";
import Pricing from "@/pages/Pricing";
import PostJob from "@/pages/PostJob";
import CustomerDashboard from "@/pages/CustomerDashboard";
import ContractorDashboard from "@/pages/ContractorDashboard";
import ContractorEditProfile from "@/pages/ContractorEditProfile";
import ContractorProfile from "@/pages/ContractorProfile";
import TradeLanding from "@/pages/TradeLanding";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSettings from "@/pages/AdminSettings";
import PaymentSuccess from "@/pages/PaymentSuccess";
import NotFound from "@/pages/NotFound";

function AppRouter() {
  const location = useLocation();
  // Process emergent oauth callback synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/categories" element={<Categories />} />
      <Route path="/trades/:slug" element={<TradeLanding />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route
        path="/customer"
        element={<ProtectedRoute role="customer"><CustomerDashboard /></ProtectedRoute>}
      />
      <Route
        path="/customer/post"
        element={<ProtectedRoute role="customer"><PostJob /></ProtectedRoute>}
      />
      <Route
        path="/contractor"
        element={<ProtectedRoute role="contractor"><ContractorDashboard /></ProtectedRoute>}
      />
      <Route
        path="/contractor/profile"
        element={<ProtectedRoute role="contractor"><ContractorEditProfile /></ProtectedRoute>}
      />
      <Route path="/pros/:id" element={<ContractorProfile />} />
      <Route
        path="/admin"
        element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>}
      />
      <Route
        path="/admin/settings"
        element={<ProtectedRoute role="admin"><AdminSettings /></ProtectedRoute>}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <SupportChat />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}
